<template>
  <button
    class="button-export-excel"
    :disabled="loading || !apiAvailable"
    @click="$emit('export')"
    :title="!apiAvailable ? 'Export indisponible hors ligne' : (loading ? 'Export en cours\u2026' : `Exporter ${count} lot${count > 1 ? 's' : ''} en Excel`)"
  >
    <span class="btn-icons">
      <i v-if="loading" class="fa-solid fa-spinner fa-spin"></i>
      <svg v-else class="excel-download-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <!-- Feuille de document -->
        <path d="M4 2h10l6 6v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" fill="currentColor" opacity="0.15"/>
        <path d="M4 3a1 1 0 0 1 1-1h9l6 6v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
        <!-- Coin plié -->
        <path d="M14 2v5a1 1 0 0 0 1 1h5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
        <!-- Lettre X (Excel) -->
        <text x="6" y="15" font-size="6" font-weight="800" font-family="Arial,sans-serif" fill="currentColor" letter-spacing="-0.5">XLS</text>
        <!-- Flèche de téléchargement en bas à droite -->
        <circle cx="18.5" cy="18.5" r="4" fill="currentColor"/>
        <path d="M18.5 15.8v4M16.5 18l2 2.3 2-2.3" fill="none" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  </button>
</template>

<script>
export default {
  name: 'ButtonExportExcel',
  emits: ['export'],
  props: {
    count: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    apiAvailable: { type: Boolean, default: false }
  },

  computed: {
    isDisabled() {
      const disabled = this.loading || !this.apiAvailable
      return disabled
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../../assets/styles/variables" as *;

.button-export-excel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: solid $darkgray 2px;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  color: $darkgray;
  transition: border-color 0.15s, color 0.15s;
  flex-shrink: 0;

  .btn-icons {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .excel-download-icon {
    width: 22px;
    height: 22px;
  }

  &:not(:disabled) {
    border-color: #1d6f42;
    color: #1d6f42;
  }

  &:hover:not(:disabled) {
    background: rgba(29, 111, 66, 0.08);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}
</style>
